import { KEEN_KEY } from '../constants';
export var mapKeys = function (map, keys, data, labelSelector) {
    if (labelSelector === void 0) { labelSelector = KEEN_KEY; }
    return ({
        keys: keys.map(function (keyName) { return map[keyName] || keyName; }),
        results: data.map(function (item) {
            var updatedData = {};
            Object.keys(item).forEach(function (keyName) {
                var mappedKey = map[keyName] || keyName;
                updatedData[mappedKey] = item[keyName];
            });
            var label = item[labelSelector];
            var hasLabelMapping = map[label];
            if (hasLabelMapping) {
                updatedData[labelSelector] = map[label];
            }
            return updatedData;
        }),
    });
};
export var createComputedKey = function (query, index) {
    return index + "." + query.event_collection + "." + query.analysis_type;
};
